import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const VCS_INTEGRATIONS_TABLE_STORAGE_KEY = "vcsIntegrationsTableStorageKey";
export const VCS_INTEGRATIONS_TABLE_FILTERS_STORAGE_KEY = "vcsIntegrationsTableFiltersStorageKey";

export enum VCS_INTEGRATIONS_COLUMN_ID {
  NAME = "NAME",
  ISSUES = "ISSUES",
  DESCRIPTION = "DESCRIPTION",
  LABELS = "LABELS",
  SPACE = "SPACE",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const VCS_INTEGRATIONS_TABLE_COLUMNS_CONFIG: Record<
  VCS_INTEGRATIONS_COLUMN_ID,
  TableColumnMeta
> = {
  [VCS_INTEGRATIONS_COLUMN_ID.NAME]: {
    id: VCS_INTEGRATIONS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [VCS_INTEGRATIONS_COLUMN_ID.ISSUES]: {
    id: VCS_INTEGRATIONS_COLUMN_ID.ISSUES,
    title: "Issues",
    minWidth: 80,
    defaultWidth: 80,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    configurable: true,
  },
  [VCS_INTEGRATIONS_COLUMN_ID.DESCRIPTION]: {
    id: VCS_INTEGRATIONS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    configurable: true,
  },
  [VCS_INTEGRATIONS_COLUMN_ID.LABELS]: {
    id: VCS_INTEGRATIONS_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 100,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    configurable: true,
  },
  [VCS_INTEGRATIONS_COLUMN_ID.SPACE]: {
    id: VCS_INTEGRATIONS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [VCS_INTEGRATIONS_COLUMN_ID.DROPDOWN]: {
    id: VCS_INTEGRATIONS_COLUMN_ID.DROPDOWN,
    title: "Integration actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    allowsSorting: false,
    canHide: false,
    configurable: false,
  },
};

const NAME_SORT_KEY = "name";

export const SORT_CONFIG: Partial<Record<VCS_INTEGRATIONS_COLUMN_ID, string>> = {
  [VCS_INTEGRATIONS_COLUMN_ID.NAME]: NAME_SORT_KEY,
  [VCS_INTEGRATIONS_COLUMN_ID.SPACE]: "space",
};

export const INITIAL_SORT_OPTION = NAME_SORT_KEY;
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
